<template>
<v-form @submit.prevent="confirmDialog = true">
<v-card class="elevation-12">
    <v-toolbar flat tabs color="grey lighten-3">
    <v-toolbar-side-icon @click="exit">
        <v-icon color="primary">close</v-icon>
    </v-toolbar-side-icon>
    <template>
        <v-toolbar-title>Editar Produtos</v-toolbar-title>
        <v-spacer></v-spacer>
    </template>
    <template v-slot:extension>
        <v-tabs
            v-model="productTab"
            fixed-tabs
            color="grey lighten-3"
            slider-color="secondary"
        >
            <v-tab ripple href="#basic">
                <span class="pr-2">Básico</span>
                <sp-tooltip tip='Comece criando seus produtos com o "Básico" e </br> havendo necessidade use o "Avançado" para ajustes.'>
                </sp-tooltip>
            </v-tab>
            <v-tab ripple href="#advanced">
                <span class="pr-2">Avançado</span>
                <sp-tooltip tip='Use o "Avançado" para ocultar produtos na </br> lista de produtos e demais configurações.'>
                </sp-tooltip>
            </v-tab>
        </v-tabs>
    </template>
    </v-toolbar>
    <v-card-text class="pa-0" id="productMultiForm">
        <v-tabs-items v-model="productTab">
            <v-tab-item value="basic">
                <v-card-text class="pt-0">
                    <v-container grid-list-md pa-0 fluid>
                        <v-layout row wrap fill-height>
                            <v-flex xs12>
                                <v-layout row wrap justify-space-between>
                                    <v-flex xs12 pb-4>
                                        <input
                                            type="file"
                                            style="display: none"
                                            ref="image"
                                            accept="image/*"
                                            @change="onFilePicked"
                                        >
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-textarea 
                                        label="Descrição" type="text" outline
                                        v-model="productForm.description"
                                        clearable rows="2" :disabled="productForm.unit == 'G'"
                                        >
                                            <template v-slot:append-outer>
                                                <v-checkbox v-model="editFields.description" hide-details></v-checkbox>
                                            </template>
                                        </v-textarea>
                                    </v-flex>
                                    <v-flex x12 md6>
                                        <v-autocomplete
                                            v-model="productForm.type_id"
                                            label="Categoria do Produto"
                                            :items="menu"
                                            item-value="_id"
                                            item-text="name"
                                            outline
                                            no-data-text="Clique no + para criar nova categoria"
                                            :filter="filter"
                                            prepend-inner-icon="add"
                                            @click:prepend-inner="createType"
                                            @change="getSubtypes"
                                        >
                                            <template v-slot:append-outer>
                                                <v-checkbox v-model="editFields.type_id" hide-details></v-checkbox>
                                            </template>
                                        </v-autocomplete>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <v-autocomplete
                                            v-model="productForm.subtype_id"
                                            label="Subcategoria do Produto"
                                            required
                                            :items="subtypes"
                                            item-value="_id"
                                            item-text="name"
                                            outline
                                            :filter="filter"
                                            :loading="stLoading"
                                        >
                                            <template v-slot:append-outer>
                                                <v-checkbox v-model="editFields.subtype_id" hide-details></v-checkbox>
                                            </template>
                                        </v-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-autocomplete
                                            v-model="productForm.combolist_id"
                                            label="Complementos"
                                            required
                                            :items="comboes"
                                            item-value="_id"
                                            item-text="description"
                                            outline
                                            :filter="filter"
                                            :loading="loading"
                                            @change="productForm.combolist_id = productForm.combolist_id || ''"
                                            clearable
                                        >
                                            <template v-slot:item="data">
                                                <v-list-tile-content>
                                                    <v-list-tile-title v-html="data.item.description"></v-list-tile-title>
                                                </v-list-tile-content>
                                            </template>
                                            <template v-slot:append-outer>
                                                <v-checkbox v-model="editFields.combolist_id" hide-details></v-checkbox>
                                            </template>
                                        </v-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-layout justify-center>
                                            <v-flex xs8 md3>
                                                <v-text-field  
                                                label="Preço" type="text"
                                                v-money="config"
                                                v-model.lazy="productForm.price"
                                                ref="price"
                                                prefix="R$"
                                                required
                                                outline
                                                :disabled="productForm.unit == 'G'"
                                                >
                                                </v-text-field>
                                            </v-flex>
                                            <v-flex xs1>
                                                <v-checkbox v-model="editFields.price" 
                                                class="mt-4"
                                                hide-details></v-checkbox>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <span v-if="error" id="error-basic" class="error--text">{{error}}</span>
                </v-card-text>
            </v-tab-item>
            <v-tab-item value="advanced" lazy>
                <v-card-text>
                    <v-container grid-list-md pa-0 fluid>
                        <v-layout row wrap justify-space-around>
                            <v-flex xs12>
                                <v-textarea 
                                label="Detalhes" type="text" outline
                                v-model="productForm.details"
                                clearable counter rows="2"
                                >
                                    <template v-slot:append-outer>
                                        <v-checkbox v-model="editFields.details" hide-details></v-checkbox>
                                    </template>
                                </v-textarea>
                            </v-flex>
                            <v-flex xs12>
                                <v-combobox
                                v-model="productForm.keywords"
                                :items="productForm.keywords"
                                :search-input.sync="search"
                                :hide-no-data="!search"
                                hide-selected
                                label="Palavras-chave"
                                multiple
                                outline
                                chips
                            >
                                <template v-slot:no-data>
                                <v-list-tile>
                                    <v-list-tile-content>
                                    <v-list-tile-title>
                                        Pressione <kbd>enter</kbd> para criar uma nova
                                    </v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                </template>
                                <template v-slot:append-outer>
                                    <v-checkbox v-model="editFields.keywords" hide-details></v-checkbox>
                                </template>
                            </v-combobox>
                            </v-flex>
                            <v-flex xs6 md3>
                                <v-text-field  
                                label="Múltiplo" type="text" outline
                                v-model="productForm.multiple"
                                >
                                    <template v-slot:append-outer>
                                        <v-checkbox v-model="editFields.multiple" hide-details></v-checkbox>
                                    </template>    
                                </v-text-field>
                            </v-flex>
                            <v-flex xs6 md3>
                                <v-text-field  
                                label="Quant. Máx. por pedido" type="number" outline
                                v-model="productForm.max_quantity"
                                hint="0 para sem limites" persistent-hint
                                >
                                    <template v-slot:append-outer>
                                        <v-checkbox v-model="editFields.max_quantity" hide-details></v-checkbox>
                                    </template>
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap justify-space-between>
                            <v-flex xs6>
                                <v-switch
                                label="Usar estoque" color="primary"
                                v-model="stockFields" @change="ChangeStockSwitch"
                                >
                                    <template v-slot:append>
                                        <sp-tooltip tip="Marque para controlar estoque do produto">
                                        </sp-tooltip>
                                    </template>
                                </v-switch>
                            </v-flex>
                            <v-flex xs6 v-if="stockFields">
                                <v-switch
                                label="Vender s/ estoque" color="primary"
                                v-model="productForm.sale_without_stock"
                                hide-details
                                >
                                    <template v-slot:append>
                                        <v-checkbox class="sp-remove-space-top" 
                                            v-model="editFields.sale_without_stock" 
                                            hide-details
                                        ></v-checkbox>
                                    </template>
                                </v-switch>
                            </v-flex>
                            <template v-if="stockFields">
                                <v-flex xs6>
                                    <v-text-field  
                                    label="Estoque" type="number" outline
                                    v-model="productForm.stock"
                                    >
                                        <template v-slot:append-outer>
                                            <v-checkbox v-model="editFields.stock" hide-details></v-checkbox>
                                        </template>
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs6>
                                    <v-text-field  
                                    label="Margem de Segurança" type="number" outline
                                    v-model="productForm.safety_margin"
                                    >
                                        <template v-slot:append-outer>
                                            <v-checkbox v-model="editFields.safety_margin" hide-details></v-checkbox>
                                        </template>
                                    </v-text-field>
                                </v-flex>
                            </template>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12 sm6 xl4>
                                <v-switch
                                label="Ocultar produto" color="primary"
                                v-model="productForm.hide_on_app"
                                >
                                    <template v-slot:append>
                                        <v-checkbox v-model="editFields.hide_on_app" hide-details class="sp-remove-space-top">
                                        </v-checkbox>
                                    </template>
                                </v-switch>
                            </v-flex>
                            <v-flex xs12 sm6 xl4>
                                <v-switch
                                label="Somente primeira compra" color="primary"
                                v-model="productForm.first_purchase_only">
                                    <template v-slot:append>
                                        <v-checkbox class="sp-remove-space-top"
                                        v-model="editFields.first_purchase_only" hide-details></v-checkbox>
                                    </template>
                                </v-switch>
                            </v-flex>
                            <v-flex xs12 sm6 xl4>
                                <v-switch
                                label="Produto promocional" color="primary" outline
                                v-model="productForm.promotional_product"
                                >
                                    <template v-slot:append>
                                        <v-checkbox class="sp-remove-space-top"
                                        v-model="editFields.promotional_product" hide-details></v-checkbox>
                                    </template>
                                </v-switch>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <span v-if="error" id="error-advanced" class="error--text">{{error}}</span>
                </v-card-text>
            </v-tab-item>
        </v-tabs-items>
    </v-card-text>
    <v-card-actions class="layout row justify-center">
        <v-btn color="success" large type="submit" class="mb-3" :loading="loading" :disabled="loading">
            Salvar Produtos
        </v-btn>
    </v-card-actions>
</v-card>
<v-snackbar
    v-model="snackbar"
    :timeout="5000"
    bottom
>
    {{snackbarText}}
    <v-btn
    color="pink"
    flat
    @click="snackbar = false"
    >
    Close
    </v-btn>
</v-snackbar>
<v-dialog v-model="confirmDialog" lazy max-width="450px" scrollable>
    <v-card>
        <v-card-text class="headline text-xs-center">
            <h4>Alterações em lote</h4>
            <v-list two-line subheader>
                <v-subheader v-if="multiProducts[0] == '*'">Alterando em {{products.recordsTotal}} produtos:</v-subheader>
                <v-subheader v-else>Alterando em {{multiProducts.length}} produtos:</v-subheader>

                <v-list-tile
                v-for="(edit,index) in editedFields"
                :key="index"
                >
                    <v-list-tile-content>
                        <v-list-tile-title v-if="productForm[edit] === ''">
                            <b>Campo vazio*</b>
                        </v-list-tile-title>
                        <v-list-tile-title v-else-if="productForm[edit].length == 0">
                            <b>Limpar palavras-chave</b>
                        </v-list-tile-title>
                        <v-list-tile-title v-else-if="typeof(productForm[edit]) === 'boolean'">
                            {{(productForm[edit])?'Ativar':'Desativar'}}
                        </v-list-tile-title>
                        <v-list-tile-title v-else-if="['type_id','subtype_id'].indexOf(edit) != -1">
                            {{(subtypes.find(v=>v._id==productForm[edit]) || menu.find(v=>v._id==productForm[edit])).name}}
                        </v-list-tile-title>
                        <v-list-tile-title v-else-if="edit == 'combolist_id'">
                            {{comboes.find(v=>v._id==productForm[edit]).description}}
                        </v-list-tile-title>
                        <v-list-tile-title v-else>
                            {{ (typeof(productForm[edit]) === 'object')?productForm[edit].join(', '):productForm[edit] }}
                        </v-list-tile-title>
                        <v-list-tile-sub-title>{{ $t('product.'+edit) }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
        <v-btn
            color="error"
            flat
            @click="confirmDialog = false"
            :disabled="loading"
        >
            Não
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
            color="success"
            @click="onSubmit();confirmDialog = false"
            :loading="loading"
            :disabled="loading"
        >
            sim
        </v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</v-form>
</template>

<script>
import {mapGetters} from 'vuex'
import SpComboSession from './SpComboSession'
import draggable from 'vuedraggable'


export default {
    $_veeValidate: {
        validator: 'new'
    },
    components:{
        SpComboSession,
        draggable
    },
    data(){
        return {
            error:null,
            config: {decimal: ',', thousands: '.', prefix: '', suffix: '', precision: 2},
            productForm:{
                price:'0,00',
                description: '',
                details:'',
                type_id:'',
                subtype_id:'',
                multiple:1,
                max_quantity:0,
                safety_margin: 0,
                first_purchase_only: false,
                promotional_product: false,
                hide_on_app:false,
                stock:0,
                sale_without_stock:true,
                active:true,
                keywords:[],
                combolist_id:''
            },
            editFields:{
                description:false,
                type_id:false,
                subtype_id:false,
                price:false,
                details:false,
                multiple:false,
                max_quantity:false,
                safety_margin:false,
                first_purchase_only: false,
                promotional_product: false,
                hide_on_app:false,
                stock:false,
                sale_without_stock:false,
                active:false,
                keywords:false,
                combolist_id:false
            },
            mode:false,
            subtypes:[{_id:'',name:'Nenhum'}],
            loading:false,
            stLoading:false,
            imageUrl: '',
            productTab:"basic",
            snackbar:false,
            snackbarText:"",
            stockFields:false,
            comboDialog:false,
            comboErrors:[],
            editComboName:false,
            combo:{
                description:"",
                selected_products:[],
                type_id:[],
                combosession_list:[],
                combo_default_value:false,
                combosession_list_data:{},
                enabled:true
            },
            comboes:[],
            newSession:false,
            delData:{func:null,id:""},
            uri:'https://api.socialplace.com.br',
            search:false,
            confirmDialog:false,
            progress:20
        }
    },
    computed:{
        ...mapGetters([
            'util',
            'restaurant',
            'menu',
            'typeSelected',
            'product',
            'products',
            'multiProducts'
        ]),
        editedFields(){
            return Object.keys(this.editFields).filter(v=>this.editFields[v])
        }
    },
    watch:{
        typeSelected(v){
            if(v){
                this.productForm.type_id = v.type_id
                this.getSubtypes()
            }
        },
        multiProducts(v){
            if(v){
                this.setForm()
            }
        },
        menu(v){
            const i = v.map(el => el.enabled).lastIndexOf(true)
            this.productForm.type_id = v[i]._id
        },
        error(v){
            if(v){
                const tagError = "#error"+((this.productTab=='basic')?'Basic':'Advanced')
                this.$vuetify.goTo(tagError,{container:"#productMultiForm"})
            }
        }
    },
    methods:{
        ChangeStockSwitch(){
            this.productForm.safety_margin = 0
            this.productForm.stock = 0
            this.productForm.sale_without_stock = true
        },
        pickFile(){
            this.$refs.image.click()
        },
        onFilePicked (e) {
			const files = e.target.files
			if(files[0] !== undefined) {				
				if(files[0].name.lastIndexOf('.') <= 0) {
					return
				}
				const fr = new FileReader ()
				fr.readAsDataURL(files[0])
				fr.addEventListener('load', () => {
					this.imageUrl = fr.result
					this.productForm.photo = fr.result // this is an image file that can be sent to server...
				})
			} else {
				this.clearImage()
			}
        },
        clearImage(){
            this.productForm.photo = ''
            this.imageUrl = ''
            this.$refs.image.value = ""
        },
        filter(item, queryText, itemText){
            return this.replaceSpecialChars(itemText.toLocaleLowerCase())
            .indexOf(this.replaceSpecialChars(queryText.toLocaleLowerCase())) > -1
        },
        replaceSpecialChars(str)
        {
            str = str.replace(/[ÀÁÂÃ]/,"A");
            str = str.replace(/[àáâã]/,"a");
            str = str.replace(/[ÈÉÊẼ]/,"E");
            str = str.replace(/[èéêẽ]/,"e");
            str = str.replace(/[ÌÍÎĨ]/,"I");
            str = str.replace(/[ìíîĩ]/,"i");
            str = str.replace(/[ÒÓÔÕ]/,"O");
            str = str.replace(/[òóôõ]/,"o");
            str = str.replace(/[ÙÚÛŨ]/,"U");
            str = str.replace(/[ùúûũ]/,"u");
            str = str.replace(/[Ç]/,"C");
            str = str.replace(/[ç]/,"c");

            return str.replace(/[^a-z0-9]/gi,''); 
        },
        async setForm(){
            this.getComboes()
        },
        resetProduct(){
            this.productForm = {
                price:'0,00',
                description: '',
                details:'',            
                type_id:'',
                subtype_id:'',
                multiple:1,
                unit:"UN",
                product_yield:1000,
                max_quantity:0,
                safety_margin: 0,
                first_purchase_only: false,
                promotional_product: false,
                hide_on_app:false,
                stock:0,
                sale_without_stock:true,
                active:true,
                keywords:[],
                combolist_id:''
            }
            this.editFields={
                price:false,
                original_price:false,
                photo:false,
                description:false,
                details:false,
                type_id:false,
                subtype_id:false,
                combolist_id:false,
                multiple:false,
                unit:false,
                max_quantity:false,
                safety_margin:false,
                first_purchase_only: false,
                promotional_product: false,
                product_yield:false,
                hide_on_app:false,
                stock:false,
                sale_without_stock:false,
                active:false,
                keywords:false
            }
            this.stockFields = false
            this.$refs.price.$el.getElementsByTagName('input')[0].value = 0.00
            if(this.productForm.unit  == 'G')
                this.$refs.original_price.$el.getElementsByTagName('input')[0].value = 0.00
            this.clearImage()
        },
        exit(){
            this.$vuetify.goTo(0,
            {
                container:"#productMultiForm"
            })
            this.$validator.reset()
            this.resetProduct()
            this.error = null
            setTimeout(() => {
                this.$store.commit("FETCH_MULTI_PRODUCTS",[])
            }, 200);
        },
        createType(){
            this.$store.commit('TOGGLE_TYPE_DIALOG')
        },
        async getSubtypes(){
            if(this.productForm.type_id != ''){
                this.stLoading = true    
                const res = await this.$store.dispatch('getSubtypes',this.productForm.type_id)
                if(res.data.ok){
                    this.subtypes = res.data.data
                }else{
                    this.subtypes = [{_id:'',name:'Nenhum'}]
                }
                this.stLoading = false
            }else{
                this.subtypes = [{_id:'',name:'Nenhum'}]
            }
        },
        async getComboes(){
            try {
                this.comboes = await this.$store.dispatch('fetchCombo')
            } catch (error) {
                console.log(error)
            }
        },
        async onSubmit(event){
            let valid = await this.$validator.validateAll()
            if(valid){
                this.loading = true
                const fields = Object.keys(this.productForm).filter(v=>this.editFields[v])
                const data = {}
                fields.forEach(v=>data[v] = this.productForm[v])
                data.product_list_id = this.multiProducts.reduce((acc,curr)=>acc.concat(curr._id || curr),[]).join(";")

                this.$store.dispatch('updateProducts',data).then(res=>{
                    this.$validator.reset()
                    this.resetProduct()
                    setTimeout(async () => {
                        this.$store.commit("FETCH_MULTI_PRODUCTS",[])
                    }, 300);
                    this.loading = false
                }).catch(err=>{
                    this.error = err
                    this.loading = false
                })
            }
        }
    }
}
</script>
<style lang="scss">
    .sp-remove-space-top{
        margin-top: 0px !important;
        padding-top: 0px !important;
    }
</style>>

</style>
